import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
import CustomDataTable from '../components/CustomDataTable'
import '../components/Common.css';
const EmployeeListReport = () => {
    const empcode = localStorage.getItem('empcode');
    const [data, setData] = useState([]);
    const [plants, setPlants] = useState([]); 
    const [departments, setDepartments] = useState([]);
    const [company, setCompany] = useState([]);
    const [vender, setVender] = useState([]);
    const { setLoading } = useLoading();
    const [search, setSearch] = useState("");
    const [filters, setFilters] = useState({
        CompanyName: '',
        PlantName: '',
        VenderName: '',
        DepartmentName: '',
        EmployeeCode: '',
        EmployeeName: '',
        DoJStart: '',
        DoJEnd: ''
    });

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [deptRes, plantRes, companyRes, venderRes] = await Promise.all([
                EmployeeProcessService.getDepartment(empcode),
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany('User'),
                EmployeeProcessService.getVender('User')
            ]);
            if (deptRes?.data?.statusCode === 200) setDepartments(deptRes.data.result);
            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result); // fixed
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const fetchData = async () => {
        debugger;
        try {
            setLoading(true);
            const response = await EmployeeProcessService.getEmployeeListReport(filters);
            if (response.data.statusCode === 200 && response.data.result.length > 0) {
                setData(response.data.result);
                setLoading(false);
                //toast.success("Data loaded");
            } else {
                setLoading(false);
                alert("No records found");
                setData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
            setLoading(false);
            alert("No records found");
        }
    };

    const applyFilters = () => {
        // if (filters.DoJStart && filters.DoJEnd && filters.DoJStart > filters.DoJEnd) {
        //     toast.error("Start date cannot be after end date.");
        //     return;
        // }
        debugger;
        fetchData();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };


    const downloadExcel = () => {
        const now = new Date();
        const currentDate = now.toLocaleDateString();
        const currentTime = now.toLocaleTimeString();
        const currentMonth = now.toLocaleString('default', { month: 'long' });

        const headerInfo = [
            ["Date", currentDate],
            ["Time", currentTime],
            ["Month", currentMonth],
            [],
        ];

        const headers = [
            ["Vendor", "Company", "Name", "Sex", "Grade", "Designation", "Qualification", "CTC", "DOJ"]
        ];

        const rows = data.map(emp => ([
            emp.venderName,
            emp.companyName,
            emp.employeeName,
            emp.gender,
            emp.gradeName,
            emp.dsignationName,
            emp.qualificationName,
            emp.ctc,
            emp.doj ? new Date(emp.doj).toISOString().split("T")[0] : ""
        ]));

        const finalData = [...headerInfo, ...headers, ...rows];

        const worksheet = XLSX.utils.aoa_to_sheet(finalData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");

        XLSX.writeFile(workbook, "EmployeeListData.xlsx");
    };

    return (
         <div className="container mt-3">
            <div className="row  filter-section">
                <div className="col-md-3">
                    <label className="filter-label text-primary" >
                        Select Company</label>
                    <select name="CompanyName" value={filters.CompanyName} onChange={handleChange}
                        className="form-select filter-input">
                        <option value="">Select Company</option>
                        {company.map(comp => (
                            <option key={comp.id} value={comp.id}>{comp.name}</option>
                        ))}
                    </select>
                </div>


                <div className="col-md-3">
                    <label className="filter-label text-primary">
                        Select Plant</label>
                    <select name="PlantName" value={filters.PlantName} onChange={handleChange}
                        className="form-select filter-input">
                        <option value="">Select Plant</option>
                        {plants.map(plan => (
                            <option key={plan.id} value={plan.id}>{plan.name}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="filter-label text-primary">
                        Select Vendor</label>
                    <select name="VenderName" value={filters.VenderName} onChange={handleChange}
                        className="form-select filter-input">
                        <option value="">Select Vendor</option>
                        {vender.map(ven => (
                            <option key={ven.id} value={ven.name}>{ven.name}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="filter-label text-primary">
                        Select Department</label>
                    <select name="DepartmentName" value={filters.DepartmentName} onChange={handleChange}
                        className="form-select filter-input">
                        <option value="">Select Department</option>
                        {departments.map(dept => (
                            <option key={dept.id} value={dept.name}>{dept.name}</option>
                        ))}
                    </select>
                </div>

                <div className="row mb-3 filter-section">
                    <div className="col-md-3">
                        <label className="filter-label text-primary">
                            DOJ From</label>
                        <input
                            type="date"
                            name="DoJStart"
                            value={filters.DoJStart}
                            onChange={handleChange}
                            className="form-select filter-input" />
                    </div>

                    <div className="col-md-3">
                        <label className="filter-label text-primary">
                            DOJ To</label>
                        <input
                            type="date"
                            name="DoJEnd"
                            value={filters.DoJEnd}
                            onChange={handleChange}
                            className="form-select filter-input" />
                    </div>
                    <div className="col-md-3">
                        <label className="filter-label text-primary">
                            Employee Code</label>
                        <input
                            name="EmployeeCode"
                            value={filters.EmployeeCode}
                            placeholder="Employee Code"
                            onChange={handleChange}
                            className="form-select filter-input"
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="filter-label text-primary">
                            Employee Name</label>
                        <input
                            name="EmployeeName"
                            value={filters.EmployeeName}
                            placeholder="Employee Name"
                            onChange={handleChange}
                            className="form-select filter-input"
                        />
                    </div>
                </div>
            </div>

           <div className="d-flex gap-2 mb-3 flex-wrap">
                <button className="btn btn-primary filter-btn" onClick={applyFilters}>Search</button>
                {data.length > 0 && (
                    <button className="btn btn-success filter-btn" onClick={downloadExcel}>Download Excel</button>
                )}
            </div>

            <div className="table-responsive">
                <CustomDataTable data={data} title="Employee List" />
            </div>
        </div>
    );
};

export default EmployeeListReport;
